/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
import { Link } from "react-router-dom";
import Globals from "../../shared/Globals";
import { qreq } from "../../shared/qrequest";
import Alert from "../Alert";
import BaseCom from "../BaseCom";
import LoadingAlert from "../LoadingAlert";
import { SidebarGlobal } from "../Sidebar";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import Icon from "../Icon";
import { Pop } from "../PopModal";
import "./Billing.css";

class ClaimList extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            query: {},
            loaded: false,
            loading: false,
            list: null
        };
    }

    async componentDidMount() {
        this.applyThemeColors();
        
        await this.load();
        this.applyThemeColors();
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    load = async () => {

        this.setState({ loading: true });
        try {
            var j = await qreq.getAsync('/api/claim/list');
            if (j.list)
                this.setState({ list: j.list });
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.alert(e);
        }

    }

    deleteSelected = async () => {
        let ids = this.state.list.filter(i => i.selected).map(i => i.id);
        if(ids.length === 0) {
            this.warning('No claims selected.');
            return
        }
        Pop.showConfirm(`Delete ${ids.length} claims?`, 'Delete Claims', async () => {
            this.setState({ submitting: true });
            try {
                let j = await qreq.postAsync('/api/claim/delete', { ids: ids });
                if (j.errorCode === 0) {
                    this.success('Deleted claims successfully.');
                    this.load();
                }
                else
                    this.alert(j.errorMessage);
            }
            catch (e) {
                console.error(e);
                this.unkownErrorCallback();
            }
            this.setState({ submitting: false });
        });
    }

    toggleItem = (e, row) => {
        row.selected = e.target.checked;
        this.setState({ list: this.state.list });
    }
    
    toggleAll = (e) => {
        this.state.list.forEach(i => {
            if(!i.isReadyToSend || !i.isSent)
                i.selected = e.target.checked;
        });
        this.setState({ list: this.state.list });
    }

    isAllSelected = () => {
        return this.state.list.filter(i => i.selected).length === this.state.list.length;
    }

    send = async () => {
        let ids = this.state.list.filter(i => i.selected).map(i => i.id);
        if(ids.length === 0) {
            this.warning('No claims selected.');
            return
        }
        Pop.showConfirm(`Send ${ids.length} claims?`, 'Send Claims', async () => {
            this.setState({ submitting: true });
            try {
                let j = await qreq.postAsync('/api/claim/send', { ids: ids });
                if (j.errorCode === 0) {
                    this.success('Sent claims successfully.');
                    this.load();
                }
                else
                    this.alert(j.errorMessage);
            }
            catch (e) {
                console.error(e);
                this.unkownErrorCallback();
            }
            this.setState({ submitting: false });
        });
    }

    showClaimError = (row) => {
        Pop.show(<p>{row.statusMessage}</p>, 'Claim Error');
    }

    render() {
        if (!this.state.list) return <LoadingAlert />;

        SidebarGlobal.setSubNav(<>
            <Link to="/claim/new" role="button" className="btn btn-primary"><Icon icon="faPlus" /> <span className="d-none d-md-inline">Generate Claims</span></Link>
            <button className="btn btn-success" onClick={this.send} disabled={this.state.submitting}><Icon icon="faMoneyBillTransfer" /> <span className="d-none d-md-inline">Send Claims</span></button>
            <button className="btn btn-danger" onClick={this.deleteSelected} disabled={this.state.submitting}><Icon icon="faTrash" /> <span className="d-none d-md-inline">Trash</span></button>
        </>);

        return <div className="container-fluid">
            <h1>Claims</h1>
            <table className="table table-striped c-datatable">
                <thead>
                    <tr>
                        <th style={{width: '25px'}}>
                            {this.state.list.filter(a => !a.isReadyToSend).length > 0 && <input type="checkbox" onChange={this.toggleAll} checked={this.isAllSelected()} />}
                        </th>
                        <th>ID</th>
                        <th>Patient Name</th>
                        <th>Service Date</th>
                        <th>Claim Count</th>
                        <th>Total Amount</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    {this.state.list.map((row, idx) => <tr key={idx}>
                        <td>
                            {row.isReadyToSend ? <Icon icon="faCheck" className="text-primary" />
                            : <input type="checkbox" onChange={e => this.toggleItem(e, row)} checked={row.selected} />}
                        </td>
                        <td><Link to={`/claim/${row.id}`}>{row.id}</Link></td>
                        <td><Link to={`/claim/${row.id}`}>{`${row.patient.firstName} ${row.patient.lastName} (${row.patient.birthDate})`}</Link></td>
                        <td>{Globals.toMDYLocalDateString(row.serviceDate)}</td>
                        <td>{row.totalClaims}</td>
                        <td>{row.totalAmount ? Globals.getCurrencyFormatter().format(row.totalAmount) : 'N/A'}</td>
                        <td>
                            {row.status === 'Error' ? <span className="text-danger" role="button" onClick={() => this.showClaimError(row)}>{row.status}</span>
                                : row.status === 'ReadyToSend' ? <span className="text-primary">{row.status}</span> : row.status}
                            
                        </td>
                    </tr>)}
                </tbody>
            </table>
            {this.state.list.length === 0 && <Alert type="info">No claims found.</Alert>}
        </div>;
    }
}

export default withParamsAndNavigate(ClaimList);